import React, { useEffect } from "react";
import { Grid, GridColumn, GridRow, ScrollNavigationSection } from "sprint-common-web";

import { CloudFileStatus } from "../../../common/types/CloudFileStatus";
import { CloudFileDetails } from "../../CloudFileDetails";
import { useCloudFileDashboard } from "../../common/context/useCloudFileDashboard";
import { useCloudFileDetails } from "../../common/useCloudFileDetails";
import { useFileRecordDetails } from "../../common/useFileRecordDetails";
import { FileRecordNavigationItem, NotesNavigationItem } from "../../navigation/CloudFileDetailsDashboardNavigation";
import { FileRecordBuzzSection } from "./buzz/FileRecordBuzzSection";
import { FileRecordContentSection } from "./content/FileRecordContentSection";
import { FileRecordLanguagesSection } from "./languages/FileRecordLanguagesSection";
import { FileRecordLibrarySection } from "./library/FileRecordLibrarySection";
import { FileRecordNotesSection } from "./notes/FileRecordNotesSection";
import { FileRecordTechnicalSection } from "./technical/FileRecordTechnicalSection";

export interface FileRecordDetailsSectionProps {
    cloudFileDetails?: CloudFileDetails;
}

export const FileRecordDetailsSection = ({}: FileRecordDetailsSectionProps): JSX.Element | null => {
    const { lookupFileRecordId, setLookupFileRecordId } = useCloudFileDashboard();
    const { data: fileRecordDetails, isLoading: isFileRecordDetailsLoading } = useFileRecordDetails(lookupFileRecordId);

    const { data: cloudFileDetails } = useCloudFileDetails();

    useEffect(() => {
        if (cloudFileDetails?.fileRecordId) {
            setLookupFileRecordId(cloudFileDetails.fileRecordId);
        }
    }, [cloudFileDetails]);

    if (!fileRecordDetails || !cloudFileDetails) {
        return null;
    }

    const areNotesDisabled = [CloudFileStatus.Rejected, CloudFileStatus.QcDone].includes(cloudFileDetails?.status);

    return (
        <Grid>
            <ScrollNavigationSection id={FileRecordNavigationItem.id}>
                <GridRow>
                    <GridColumn sm={7}>
                        <FileRecordLibrarySection
                            fileRecordDetails={fileRecordDetails}
                            isFileRecordDetailsLoading={isFileRecordDetailsLoading}
                        />
                    </GridColumn>
                    <GridColumn sm={5}>
                        <FileRecordContentSection
                            fileRecordDetails={fileRecordDetails}
                            isFileRecordDetailsLoading={isFileRecordDetailsLoading}
                        />
                    </GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn sm={8}>
                        <FileRecordTechnicalSection
                            fileRecordDetails={fileRecordDetails}
                            isFileRecordDetailsLoading={isFileRecordDetailsLoading}
                        />
                    </GridColumn>
                    <FileRecordBuzzSection
                        fileRecordDetails={fileRecordDetails}
                        isFileRecordDetailsLoading={isFileRecordDetailsLoading}
                    />
                </GridRow>
                <GridRow>
                    <GridColumn sm={6}>
                        <FileRecordLanguagesSection
                            fileRecordDetails={fileRecordDetails}
                            isFileRecordDetailsLoading={isFileRecordDetailsLoading}
                        />
                    </GridColumn>
                    <GridColumn sm={6}>
                        <ScrollNavigationSection id={NotesNavigationItem.id}>
                            <FileRecordNotesSection areNotesDisabled={areNotesDisabled} />
                        </ScrollNavigationSection>
                    </GridColumn>
                </GridRow>
            </ScrollNavigationSection>
        </Grid>
    );
};
